import { render, staticRenderFns } from "./plusCardMore.vue?vue&type=template&id=2ab0820a&scoped=true&"
import script from "./plusCardMore.vue?vue&type=script&lang=js&"
export * from "./plusCardMore.vue?vue&type=script&lang=js&"
import style0 from "./plusCardMore.vue?vue&type=style&index=0&id=2ab0820a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab0820a",
  null
  
)

component.options.__file = "plusCardMore.vue"
export default component.exports